import React, { useCallback, memo } from 'react';

const Hero = () => {
  const handleScroll = useCallback((e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-purple-600 via-purple-700 to-purple-900 text-white py-20 lg:py-32 overflow-hidden">
      {/* Image de fond chargée uniquement sur desktop pour améliorer LCP mobile */}
      <div className="absolute inset-0 opacity-20 hidden lg:block">
        <img 
          src="/images/kirill-zharkiy-ItKtQ-OaIzQ-unsplash.webp" 
          alt="" 
          loading="lazy"
          decoding="async"
          width="1920"
          height="1080"
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Votre Guide Expert des Meilleures Offres de Paris en France
          </h1>
          <p className="text-xl md:text-2xl text-purple-100 mb-8 max-w-3xl mx-auto">
            Comparez les meilleures promotions, bonus exclusifs et offres de bienvenue des sites de paris les plus fiables. 
            Maximisez vos gains dès le premier pari.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <a
              href="#offres"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'offres')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              Offres
            </a>
            <a
              href="#a-propos"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'a-propos')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              À propos
            </a>
            <a
              href="#guides"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'guides')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              Guides
            </a>
            <a
              href="#faq"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'faq')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              FAQ
            </a>
            <a
              href="#actualites"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'actualites')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              Actualités
            </a>
            <a
              href="#contact"
              data-discover="true"
              onClick={(e) => handleScroll(e, 'contact')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition border border-white/20"
            >
              Contact
            </a>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default memo(Hero);

